import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router keeps the scroll position between pages, so a link clicked at
// the bottom of one page opened the next one scrolled down. Start each page at
// the top, unless the link points at a section (#features), which the page
// scrolls to itself.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
